// The server sends a recon's qualifier inside the label itself — "New Sanctions (Lender Wise)",
// "Net-worth (Share Capital + Reserves)" (underwriting-engine RECON_LABELS). The design renders
// the name in the body colour and the bracketed qualifier muted, so the split is presentational
// and happens here rather than by asking the API for two fields.

interface SplitReconLabel {
    name: string;
    qualifier: string | null;
}

/** Splits a TRAILING parenthetical off a recon label. A label with no brackets, or with brackets
 *  anywhere but the end, is returned whole — guessing at an inner bracket would mute the wrong
 *  half of something like "EPF / Statutory Dues". */
export function splitReconLabel(label: string): SplitReconLabel {
    const match = /^(.*\S)\s*(\([^()]*\))$/.exec(label.trim());
    if (!match) return { name: label, qualifier: null };
    return { name: match[1], qualifier: match[2] };
}
